import { GraduationCap } from 'lucide-react';
import dayjs from '../lib/dates';
import type { ListedConversation } from '../lib/unifiedMessaging';
import { KIND_LABELS } from './StudentMessageParts';

/** Heure pour aujourd'hui, date sinon. */
function listStamp(at: number): string {
  const date = dayjs(at);
  const now = dayjs();
  if (date.isSame(now, 'day')) return date.format('HH:mm');
  return date.format(date.isSame(now, 'year') ? 'D MMM' : 'DD/MM/YYYY');
}

/**
 * Liste unique de l'écran « Messages » : conversations de l'équipe et
 * conversations avec des élèves, déjà triées. Une conversation où un élève lit
 * porte toujours sa marque (« Élève », « Groupe avec élèves »).
 */
export default function ConversationList({
  items,
  onOpen,
}: {
  items: ListedConversation[];
  onOpen: (conversation: ListedConversation) => void;
}) {
  if (!items.length) return null;
  return (
    <ul aria-label="Conversations" className="space-y-2">
      {items.map((c) => (
        <li key={`${c.origin}:${c.id}`}>
          <button
            type="button"
            className="block w-full text-left rounded-xl border p-3"
            onClick={() => onOpen(c)}
          >
            <span className="flex items-start gap-2">
              <span
                className={`flex-1 min-w-0 break-words ${
                  c.unread > 0 ? 'font-semibold' : ''
                }`}
              >
                {c.title} · {c.unread} non lu(s)
              </span>
              {c.at > 0 && (
                <span className="flex-shrink-0 pt-0.5 text-xs text-slate-400">
                  {listStamp(c.at)}
                </span>
              )}
            </span>
            {c.origin === 'student' && (
              <span className="mt-1 flex items-center gap-2">
                <span className="flex-shrink-0 inline-flex items-center gap-1 rounded-full border border-amber-200 bg-amber-50 px-2 py-0.5 text-xs font-medium text-amber-900">
                  <GraduationCap size={13} aria-hidden="true" />
                  {KIND_LABELS[c.kind] ?? 'Élève'}
                </span>
                <span className="min-w-0 truncate text-sm text-slate-500">
                  {c.last
                    ? `${c.last.author} : ${c.last.body}`
                    : 'Aucun message'}
                </span>
              </span>
            )}
          </button>
        </li>
      ))}
    </ul>
  );
}
